var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ed-dialog',{ref:"BasicDialog",attrs:{"fullscreen":true,"showOkBtn":false,"visible":_vm.visible,"title":"接口变量管理"},on:{"close":_vm.closeDialog}},[_c('easy-data-list',{ref:"EasyDataList",attrs:{"data-source-name":_vm.dataSourceName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }